let content_blocks = require('../contents');

export function init(microsite_id, content_id){

    $('#edit_gallery_modal .btn.delete').on('click', function(){

        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();

        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');
        modal.find('form')[0].reset();

    });

    $('#edit_gallery').find('.visibility-devices span').each(function(){
        $(this).on('click', function(){
            let hidden = $(this).attr('data-hidden') == true || $(this).attr('data-hidden') == 'true' ? true : false;
            change_device_visible($(this), !hidden);
            $(this).attr('data-hidden', !hidden);
        });
    });

    function change_device_visible(button, hidden){
        if (hidden == true || hidden == 'true') {
            button.css({"background-color": "#f8f9fa"});
        } else {
            button.css({"background-color": "#d3d6d9"});
        }
    }

    $('#edit_gallery_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        let device_mobile = modal.find('.visibility-devices [data-device="mobile"]');
        device_mobile.attr('data-hidden', block.attr('data-mobile-hidden'));
        change_device_visible(device_mobile, block.attr('data-mobile-hidden'));
        
        let device_tablet = modal.find('.visibility-devices  [data-device="tablet"]');
        device_tablet.attr('data-hidden', block.attr('data-tablet-hidden'));
        change_device_visible(device_tablet, block.attr('data-tablet-hidden'));
        
        let device_desktop = modal.find('.visibility-devices [data-device="desktop"]');
        device_desktop.attr('data-hidden', block.attr('data-desktop-hidden'));
        change_device_visible(device_desktop, block.attr('data-desktop-hidden'));

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="xs_images"]').val(block.attr('data-xs-images'));
        modal.find('[name="md_images"]').val(block.attr('data-md-images'));
        modal.find('[name="xl_images"]').val(block.attr('data-xl-images'));

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_gallery').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        
        let device_mobile = $(this).find('.visibility-devices [data-device="mobile"]');
        block.attr('data-mobile-hidden', device_mobile.attr('data-hidden'));
        
        let device_tablet = $(this).find('.visibility-devices  [data-device="tablet"]');
        block.attr('data-tablet-hidden', device_tablet.attr('data-hidden'));
        
        let device_desktop = $(this).find('.visibility-devices [data-device="desktop"]');
        block.attr('data-desktop-hidden', device_desktop.attr('data-hidden'));
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-xs-images', $(this).find('[name="xs_images"]').val());
        block.attr('data-md-images', $(this).find('[name="md_images"]').val());
        block.attr('data-xl-images', $(this).find('[name="xl_images"]').val());
        
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');

        $(this)[0].reset();
    });

    $('#add_slide_gallery_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let prev_slide = $(button).closest('.slide_gallery');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="prev_slide_gallery_id"]').val(prev_slide.attr('id'));

        let select_visible = modal.find('[name="visible"]');

        select_visible.find('option[value="visible"]').prop('selected', true);

        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_slide_gallery_modal .btn.delete').on('click', function(){
        
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="slide_gallery_id"]').val();
        let row_id = $('#'+block_id).closest('.block').attr('id');
        $('#'+block_id).remove();

        show_block_order(row_id);
        init_gallery_block(row_id);

        modal.modal('hide');
        modal.find('form')[0].reset();

    });

    $('#edit_slide_gallery').on("submit", function(e) {
        e.preventDefault();

        let form = $(this);
        save_slide_atributes(form);
        
    });

    $('#add_slide_gallery').on("submit", function(e) {
        e.preventDefault();

        let form_data = new FormData($(this)[0]);

        let newImages = form_data.getAll('media[]');

        let media_ids = [];
        newImages.forEach(function(element, key) {
            media_ids.push(window.app.microsites.contents.get_random_id(10));
        });

        form_data.append('new_block_id', window.app.microsites.contents.get_random_id(10));
        form_data.append('media_ids', JSON.stringify(media_ids));
        form_data.append('type', 'slide_gallery');
        let modal = $(this).closest('.modal');
        modal.modal('hide');
        $(this)[0].reset();

        get_slide_view(form_data);
        
    });

    $('#content_blocks .gallery').closest('.block').each(function(){
        init_slides($(this).attr('id'));
    });

    $('.block[data-type="gallery"]').each(function(){
        init_gallery_block($(this).attr('id'));
        content_blocks.create_visible_button_blocks($(this));
    });
}

function save_slide_atributes(form) {

    let slide = $('#'+ form.find('[name="slide_gallery_id"]').val());

    let alt = form.find('[name="alt"]').val();

    slide.attr('data-class', form.find('[name="classes"]').val());
    slide.attr('data-visible', form.find('[name="visible"]').val());
    slide.attr('data-alt', alt);
    slide.attr('data-img-footer', form.find('[name="img_footer"]').val());

    let form_data = new FormData(form[0]);
    form_data.append('new_block_id', form.find('[name="slide_gallery_id"]').val());
    form_data.append('type', 'slide_gallery');

    if (form_data.get('media') != null && form_data.get('media').name != '') {
        update_slide_image(form_data, slide);
    }

    content_blocks.change_visible_button_blocks(slide);

    let modal = form.closest('.modal');
    modal.modal('hide');
    
    form[0].reset();
}

export function get_slide_view(form_data) {

    let url = window._routes['microsites.contents.block'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    window.forms.post(url, form_data, true, true)
            .then((response) => {
                if (response.data.message) {
                    switch (response.data.message_level) {
                        case 'error':
                            window.messages.error(response.data.message);
                            break;
    
                        case 'warning':
                            window.messages.warning(response.data.message);
                            break;
                    
                        default:
                            window.messages.info(response.data.message);
                            break;
                    }
                    
                } else {
                    if (response.data.prev_slide_gallery_id != null) {
                        $('#' + response.data.prev_slide_gallery_id).after(response.data.slide_gallery);
                    } else {
                        $('#' + response.data.row_id + ' .gallery').append(response.data.slide_gallery);
                    }

                    init_slides(response.data.row_id);
                    init_gallery_block(response.data.row_id);
                    
                }
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
}

export function show_block_order(row_id){

    let slides = $('#' + row_id +' .gallery .slide_gallery');

    if (slides.length > 1) {

        for(let i=0; i<slides.length; i++){

            $(slides[i]).find('.slide_up').show().prop('disabled', i == 0);
            $(slides[i]).find('.slide_down').show().prop('disabled', i == slides.length - 1);
            $(slides[i]).find('.move_slide').show();
    
            content_blocks.show_block_order($(slides[i]).attr('id'));
        }

    } else {

        for(let i=0; i<slides.length; i++){

            $(slides[i]).find('.slide_up').hide().prop('disabled', i == 0);
            $(slides[i]).find('.slide_down').hide().prop('disabled', i == slides.length - 1);
            $(slides[i]).find('.move_slide').hide();
    
            content_blocks.show_block_order($(slides[i]).attr('id'));
        }
    }
}

export function init_slides(row_id){

    $('#content_blocks #' + row_id + ' .gallery .slide_gallery:not(.init)').each(function(){
        let slide_gallery_id = $(this).attr('id');

        $('#' + slide_gallery_id).find('.btn.slide_up').click(function(){
                
            let row_id = $(this).closest('.block[data-type="gallery"]').attr('id');
            
            let slide = $(this).closest('.slide_gallery');
            let prev_slide = slide.prev();
            slide.detach();
            prev_slide.before(slide);

            show_block_order(row_id);

        });

        $('#' + slide_gallery_id).find('.btn.slide_down').click(function(){
            let row_id = $(this).closest('.block[data-type="gallery"]').attr('id');
            let slide = $(this).closest('.slide_gallery');
            let next_slide = slide.next();
            slide.detach();
            next_slide.after(slide);
            
            show_block_order(row_id);
        });

        $('#' + slide_gallery_id).find('.btn.slide_edit').click(function(){
            
            let form = $('#edit_slide_gallery');
            let slide = $(this).closest('.slide_gallery');
            let block = $(this).closest('.block');

            form.find('[name="block_id"]').val(block.attr('id'));
            form.find('[name="slide_gallery_id"]').val(slide.attr('id'));
            form.find('[name="classes"]').val(slide.attr('data-class'));
            form.find('[name="alt"]').val(slide.attr('data-alt'));
            form.find('[name="img_footer"]').val(slide.attr('data-img-footer'));

            let select_visible = form.find('[name="visible"]');
            
            if (slide.attr('data-visible') != null || slide.attr('data-visible') != 'undefined') {
                select_visible.find('option[value="'+ slide.attr('data-visible')).prop('selected', true);
            } else {
                select_visible.find('option[value="visible"]').prop('selected', true);
            }
            
            select_visible.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });


            let image = form.find('input[name="media"]');
            let label = image.next('label');
            label.text(slide.attr('data-img-name'));
        });


        content_blocks.create_visible_button_blocks($(this));
        // // inicializar bloque
        $(this).addClass('init');
        
    });
    
    show_block_order(row_id);

}

export function init_gallery_block(block_id) {

    let block = $('#content_blocks #' + block_id);
    let card_body = block.find('.card-body');
    let card_empty_body = block.find('.card-empty-body');
    if (card_body.find('.slide_gallery').length <= 0) {
        card_empty_body.removeClass('d-none');
        card_empty_body.addClass(['d-flex', 'justify-content-center']);
    } else {
        card_empty_body.addClass('d-none');
        card_empty_body.removeClass('d-flex');
    }

    $('#content_blocks #' + block_id + ' .gallery .move_slide').each(function(){

        $(this)[0].addEventListener("dragstart", (event) => {
            event.stopPropagation();

            let block = $(event.target).closest('.drag-container');
            block.addClass('dragging');

            let slide = $(event.target).closest('.slide_gallery');

            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', slide.attr('id'));

            var dragImage = document.createElement('div');
            dragImage.id = 'drag-handler';
            dragImage.innerHTML = '<i class="fa-solid fa-plane"></i>';
            dragImage.setAttribute('style', 'position: absolute; left: 0px; top: 0px; width: 30px; height: 30px; z-index: -1');
            document.body.appendChild(dragImage);
            event.dataTransfer.setDragImage(dragImage, 20, 20);

        });
    
        $(this)[0].addEventListener("dragend", (event) => {
        
            $('#drag-handler').remove();
            
            let block = $(event.target).closest('.drag-container');
            block.removeClass('dragging');
    
        });

    });

    $('#content_blocks #' + block_id + ' .gallery > .slide_gallery > .btn-drop').each(function(){
        
        $(this)[0].addEventListener("dragover", (event) => {
            event.preventDefault();
        });

        $(this)[0].addEventListener("dragenter", (event) => {
            event.preventDefault();
            if(event.dataTransfer.getData('text/plain') != $(event.target).closest('.slide_gallery').attr('id')){
                $(event.target).addClass('drop');
            }
        });

        $(this)[0].addEventListener("dragleave", (event) => {
            event.preventDefault();
            $(event.target).removeClass('drop');
        });
    
        $(this)[0].addEventListener("drop", (event) => {
            event.stopPropagation();

            let slide = $('#' + event.dataTransfer.getData('text/plain'));
            let move_after = $(event.target).closest('.slide_gallery');

            if(
                slide.length > 0 
                && move_after.length > 0
                && slide.attr('id') != move_after.attr('id')
            ){
                move_after.after(slide.detach());
            }
            
        });
    });
}

function update_slide_image(form_data, slide) {
    let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    form_data.append('type', slide.attr('data-type'));
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                slide.attr('data-img-url', response.data.src);
                slide.attr('data-img-name', response.data.name);
                slide.attr('data-media-id', response.data.media_id);
                let card_body = slide.find('.card-body');
                card_body.find('img').attr('src', response.data.src);
            }
                            
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}